import {
  ImageAttachRequest,
  PostCreateExamRequest,
  PostS3Key,
  uploadCommentRequest,
} from "../interface/apiInterface";
import customAxios from "./handler";

const postApi = {
  postDisconnectProgressing: (hostEmail: string) => {
    return customAxios.post(
      `/api/v1/users/enterprise/manager/disconn/progressing-test`,
      hostEmail
    );
  },
  postCreateTestInd: (data: PostCreateExamRequest) => {
    return customAxios.post(`/api/v1/tests/individual/create`, data);
  },
  postCreateTestEnt: (data: PostCreateExamRequest) => {
    return customAxios.post(`/api/v1/tests/enterprise/create`, data);
  },
  uploadComment: ({
    context,
    uid,
    questionComponentUid,
    s3KeyList,
  }: uploadCommentRequest) => {
    return customAxios.post(`/api/v1/questions/components`, {
      context: context,
      questionUuid: uid,
      questionComponentUuid: questionComponentUid,
      confirmImageS3KeyList: s3KeyList,
    });
  },
  getS3Key: ({
    hostUuid,
    hostEmail,
    questionUuid,
    questionComponentUuid,
  }: ImageAttachRequest) => {
    return customAxios.post<PostS3Key>(
      `/api/v1/questions/components/pre-signed-url`,
      {
        hostUuid,
        hostEmail,
        questionUuid,
        questionComponentUuid,
      }
    );
  },
};

export default postApi;
